/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as ComecarRouteImport } from './routes/comecar'
import { Route as ConviteRouteImport } from './routes/convite'
import { Route as LoginRouteImport } from './routes/login'
import { Route as TrocarSenhaRouteImport } from './routes/trocar-senha'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppAjudaRouteImport } from './routes/_app/ajuda'
import { Route as AppClientesRouteImport } from './routes/_app/clientes'
import { Route as AppConfiguracoesRouteImport } from './routes/_app/configuracoes'
import { Route as AppContaRouteImport } from './routes/_app/conta'
import { Route as AppRelatorioRouteImport } from './routes/_app/relatorio'
import { Route as DevComponentesRouteImport } from './routes/_dev/componentes'
import { Route as AppCadastrosCargosRouteImport } from './routes/_app/cadastros.cargos'
import { Route as AppCadastrosCategoriasRouteImport } from './routes/_app/cadastros.categorias'
import { Route as AppCadastrosCondicoesRouteImport } from './routes/_app/cadastros.condicoes'
import { Route as AppCadastrosEmpresaRouteImport } from './routes/_app/cadastros.empresa'
import { Route as AppCadastrosFornecedoresRouteImport } from './routes/_app/cadastros.fornecedores'
import { Route as AppCadastrosImobilizadosRouteImport } from './routes/_app/cadastros.imobilizados'
import { Route as AppCadastrosPessoasRouteImport } from './routes/_app/cadastros.pessoas'
import { Route as AppCadastrosTabelasRouteImport } from './routes/_app/cadastros.tabelas'
import { Route as AppCadastrosUnidadesRouteImport } from './routes/_app/cadastros.unidades'
import { Route as AppCadastrosUsuariosRouteImport } from './routes/_app/cadastros.usuarios'
import { Route as AppConfiguracoesIndexRouteImport } from './routes/_app/configuracoes.index'
import { Route as AppConfiguracoesEmpresaRouteImport } from './routes/_app/configuracoes.empresa'
import { Route as AppConfiguracoesEmpresasRouteImport } from './routes/_app/configuracoes.empresas'
import { Route as AppConfiguracoesErpRouteImport } from './routes/_app/configuracoes.erp'
import { Route as AppConfiguracoesGruposRouteImport } from './routes/_app/configuracoes.grupos'
import { Route as AppConfiguracoesIntegracoesRouteImport } from './routes/_app/configuracoes.integracoes'
import { Route as AppConfiguracoesOnboardingRouteImport } from './routes/_app/configuracoes.onboarding'
import { Route as AppConfiguracoesPerfisRouteImport } from './routes/_app/configuracoes.perfis'
import { Route as AppConfiguracoesPlanoRouteImport } from './routes/_app/configuracoes.plano'
import { Route as AppConfiguracoesReformaRouteImport } from './routes/_app/configuracoes.reforma'
import { Route as AppConfiguracoesTenantsRouteImport } from './routes/_app/configuracoes.tenants'
import { Route as AppConfiguracoesUsuariosRouteImport } from './routes/_app/configuracoes.usuarios'
import { Route as AppCustosCentrosRouteImport } from './routes/_app/custos.centros'
import { Route as AppCustosCifsRouteImport } from './routes/_app/custos.cifs'
import { Route as AppCustosConfiguracoesRateioRouteImport } from './routes/_app/custos.configuracoes-rateio'
import { Route as AppCustosCriteriosRouteImport } from './routes/_app/custos.criterios'
import { Route as AppCustosItensCifRouteImport } from './routes/_app/custos.itens-cif'
import { Route as AppCustosPessoalRouteImport } from './routes/_app/custos.pessoal'
import { Route as AppCustosRateiosRouteImport } from './routes/_app/custos.rateios'
import { Route as AppPlanoIndexRouteImport } from './routes/_app/plano.index'
import { Route as AppPlanoCarteiraRouteImport } from './routes/_app/plano.carteira'
import { Route as AppPlanoComprasRouteImport } from './routes/_app/plano.compras'
import { Route as AppPlanoCustoFabricaRouteImport } from './routes/_app/plano.custo-fabrica'
import { Route as AppPlanoFluxoRouteImport } from './routes/_app/plano.fluxo'
import { Route as AppPlanoNecessidadeRouteImport } from './routes/_app/plano.necessidade'
import { Route as AppPrecificarFormacaoRouteImport } from './routes/_app/precificar.formacao'
import { Route as AppPrecificarListaRouteImport } from './routes/_app/precificar.lista'
import { Route as AppPrecificarMargensRouteImport } from './routes/_app/precificar.margens'
import { Route as AppPrecificarSimuladorRouteImport } from './routes/_app/precificar.simulador'
import { Route as AppCadastrosItensIndexRouteImport } from './routes/_app/cadastros.itens.index'
import { Route as AppCadastrosItensIdRouteImport } from './routes/_app/cadastros.itens.$id'
import { Route as AppCadastrosItensNovoRouteImport } from './routes/_app/cadastros.itens.novo'
import { Route as AppConfiguracoesIntegracoesIndexRouteImport } from './routes/_app/configuracoes.integracoes.index'
import { Route as AppConfiguracoesIntegracoesApiRouteImport } from './routes/_app/configuracoes.integracoes.api'
import { Route as AppConfiguracoesIntegracoesLogsRouteImport } from './routes/_app/configuracoes.integracoes.logs'
import { Route as AppConfiguracoesIntegracoesProtheusRouteImport } from './routes/_app/configuracoes.integracoes.protheus'
import { Route as AppCustosAtualizacoesIndexRouteImport } from './routes/_app/custos.atualizacoes.index'
import { Route as AppCustosAtualizacoesIdRouteImport } from './routes/_app/custos.atualizacoes.$id'
import { Route as AppCustosFichasTecnicasIndexRouteImport } from './routes/_app/custos.fichas-tecnicas.index'
import { Route as AppCustosFichasTecnicasIdRouteImport } from './routes/_app/custos.fichas-tecnicas.$id'
import { Route as AppVenderOrcamentosIndexRouteImport } from './routes/_app/vender.orcamentos.index'
import { Route as AppVenderOrcamentosIdRouteImport } from './routes/_app/vender.orcamentos.$id'
import { Route as AppVenderOrcamentosKanbanRouteImport } from './routes/_app/vender.orcamentos.kanban'
import { Route as AppVenderOrcamentosNovoRouteImport } from './routes/_app/vender.orcamentos.novo'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const ComecarRoute = ComecarRouteImport.update({
  id: '/comecar',
  path: '/comecar',
  getParentRoute: () => rootRouteImport,
} as any)
const ConviteRoute = ConviteRouteImport.update({
  id: '/convite',
  path: '/convite',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const TrocarSenhaRoute = TrocarSenhaRouteImport.update({
  id: '/trocar-senha',
  path: '/trocar-senha',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppAjudaRoute = AppAjudaRouteImport.update({
  id: '/ajuda',
  path: '/ajuda',
  getParentRoute: () => AppRoute,
} as any)
const AppClientesRoute = AppClientesRouteImport.update({
  id: '/clientes',
  path: '/clientes',
  getParentRoute: () => AppRoute,
} as any)
const AppConfiguracoesRoute = AppConfiguracoesRouteImport.update({
  id: '/configuracoes',
  path: '/configuracoes',
  getParentRoute: () => AppRoute,
} as any)
const AppContaRoute = AppContaRouteImport.update({
  id: '/conta',
  path: '/conta',
  getParentRoute: () => AppRoute,
} as any)
const AppRelatorioRoute = AppRelatorioRouteImport.update({
  id: '/relatorio',
  path: '/relatorio',
  getParentRoute: () => AppRoute,
} as any)
const DevComponentesRoute = DevComponentesRouteImport.update({
  id: '/_dev/componentes',
  path: '/componentes',
  getParentRoute: () => rootRouteImport,
} as any)
const AppCadastrosCargosRoute = AppCadastrosCargosRouteImport.update({
  id: '/cadastros/cargos',
  path: '/cadastros/cargos',
  getParentRoute: () => AppRoute,
} as any)
const AppCadastrosCategoriasRoute = AppCadastrosCategoriasRouteImport.update({
  id: '/cadastros/categorias',
  path: '/cadastros/categorias',
  getParentRoute: () => AppRoute,
} as any)
const AppCadastrosCondicoesRoute = AppCadastrosCondicoesRouteImport.update({
  id: '/cadastros/condicoes',
  path: '/cadastros/condicoes',
  getParentRoute: () => AppRoute,
} as any)
const AppCadastrosEmpresaRoute = AppCadastrosEmpresaRouteImport.update({
  id: '/cadastros/empresa',
  path: '/cadastros/empresa',
  getParentRoute: () => AppRoute,
} as any)
const AppCadastrosFornecedoresRoute =
  AppCadastrosFornecedoresRouteImport.update({
    id: '/cadastros/fornecedores',
    path: '/cadastros/fornecedores',
    getParentRoute: () => AppRoute,
  } as any)
const AppCadastrosImobilizadosRoute =
  AppCadastrosImobilizadosRouteImport.update({
    id: '/cadastros/imobilizados',
    path: '/cadastros/imobilizados',
    getParentRoute: () => AppRoute,
  } as any)
const AppCadastrosPessoasRoute = AppCadastrosPessoasRouteImport.update({
  id: '/cadastros/pessoas',
  path: '/cadastros/pessoas',
  getParentRoute: () => AppRoute,
} as any)
const AppCadastrosTabelasRoute = AppCadastrosTabelasRouteImport.update({
  id: '/cadastros/tabelas',
  path: '/cadastros/tabelas',
  getParentRoute: () => AppRoute,
} as any)
const AppCadastrosUnidadesRoute = AppCadastrosUnidadesRouteImport.update({
  id: '/cadastros/unidades',
  path: '/cadastros/unidades',
  getParentRoute: () => AppRoute,
} as any)
const AppCadastrosUsuariosRoute = AppCadastrosUsuariosRouteImport.update({
  id: '/cadastros/usuarios',
  path: '/cadastros/usuarios',
  getParentRoute: () => AppRoute,
} as any)
const AppConfiguracoesIndexRoute = AppConfiguracoesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppConfiguracoesRoute,
} as any)
const AppConfiguracoesEmpresaRoute = AppConfiguracoesEmpresaRouteImport.update({
  id: '/empresa',
  path: '/empresa',
  getParentRoute: () => AppConfiguracoesRoute,
} as any)
const AppConfiguracoesEmpresasRoute =
  AppConfiguracoesEmpresasRouteImport.update({
    id: '/empresas',
    path: '/empresas',
    getParentRoute: () => AppConfiguracoesRoute,
  } as any)
const AppConfiguracoesErpRoute = AppConfiguracoesErpRouteImport.update({
  id: '/erp',
  path: '/erp',
  getParentRoute: () => AppConfiguracoesRoute,
} as any)
const AppConfiguracoesGruposRoute = AppConfiguracoesGruposRouteImport.update({
  id: '/grupos',
  path: '/grupos',
  getParentRoute: () => AppConfiguracoesRoute,
} as any)
const AppConfiguracoesIntegracoesRoute =
  AppConfiguracoesIntegracoesRouteImport.update({
    id: '/integracoes',
    path: '/integracoes',
    getParentRoute: () => AppConfiguracoesRoute,
  } as any)
const AppConfiguracoesOnboardingRoute =
  AppConfiguracoesOnboardingRouteImport.update({
    id: '/onboarding',
    path: '/onboarding',
    getParentRoute: () => AppConfiguracoesRoute,
  } as any)
const AppConfiguracoesPerfisRoute = AppConfiguracoesPerfisRouteImport.update({
  id: '/perfis',
  path: '/perfis',
  getParentRoute: () => AppConfiguracoesRoute,
} as any)
const AppConfiguracoesPlanoRoute = AppConfiguracoesPlanoRouteImport.update({
  id: '/plano',
  path: '/plano',
  getParentRoute: () => AppConfiguracoesRoute,
} as any)
const AppConfiguracoesReformaRoute = AppConfiguracoesReformaRouteImport.update({
  id: '/reforma',
  path: '/reforma',
  getParentRoute: () => AppConfiguracoesRoute,
} as any)
const AppConfiguracoesTenantsRoute = AppConfiguracoesTenantsRouteImport.update({
  id: '/tenants',
  path: '/tenants',
  getParentRoute: () => AppConfiguracoesRoute,
} as any)
const AppConfiguracoesUsuariosRoute =
  AppConfiguracoesUsuariosRouteImport.update({
    id: '/usuarios',
    path: '/usuarios',
    getParentRoute: () => AppConfiguracoesRoute,
  } as any)
const AppCustosCentrosRoute = AppCustosCentrosRouteImport.update({
  id: '/custos/centros',
  path: '/custos/centros',
  getParentRoute: () => AppRoute,
} as any)
const AppCustosCifsRoute = AppCustosCifsRouteImport.update({
  id: '/custos/cifs',
  path: '/custos/cifs',
  getParentRoute: () => AppRoute,
} as any)
const AppCustosConfiguracoesRateioRoute =
  AppCustosConfiguracoesRateioRouteImport.update({
    id: '/custos/configuracoes-rateio',
    path: '/custos/configuracoes-rateio',
    getParentRoute: () => AppRoute,
  } as any)
const AppCustosCriteriosRoute = AppCustosCriteriosRouteImport.update({
  id: '/custos/criterios',
  path: '/custos/criterios',
  getParentRoute: () => AppRoute,
} as any)
const AppCustosItensCifRoute = AppCustosItensCifRouteImport.update({
  id: '/custos/itens-cif',
  path: '/custos/itens-cif',
  getParentRoute: () => AppRoute,
} as any)
const AppCustosPessoalRoute = AppCustosPessoalRouteImport.update({
  id: '/custos/pessoal',
  path: '/custos/pessoal',
  getParentRoute: () => AppRoute,
} as any)
const AppCustosRateiosRoute = AppCustosRateiosRouteImport.update({
  id: '/custos/rateios',
  path: '/custos/rateios',
  getParentRoute: () => AppRoute,
} as any)
const AppPlanoIndexRoute = AppPlanoIndexRouteImport.update({
  id: '/plano/',
  path: '/plano/',
  getParentRoute: () => AppRoute,
} as any)
const AppPlanoCarteiraRoute = AppPlanoCarteiraRouteImport.update({
  id: '/plano/carteira',
  path: '/plano/carteira',
  getParentRoute: () => AppRoute,
} as any)
const AppPlanoComprasRoute = AppPlanoComprasRouteImport.update({
  id: '/plano/compras',
  path: '/plano/compras',
  getParentRoute: () => AppRoute,
} as any)
const AppPlanoCustoFabricaRoute = AppPlanoCustoFabricaRouteImport.update({
  id: '/plano/custo-fabrica',
  path: '/plano/custo-fabrica',
  getParentRoute: () => AppRoute,
} as any)
const AppPlanoFluxoRoute = AppPlanoFluxoRouteImport.update({
  id: '/plano/fluxo',
  path: '/plano/fluxo',
  getParentRoute: () => AppRoute,
} as any)
const AppPlanoNecessidadeRoute = AppPlanoNecessidadeRouteImport.update({
  id: '/plano/necessidade',
  path: '/plano/necessidade',
  getParentRoute: () => AppRoute,
} as any)
const AppPrecificarFormacaoRoute = AppPrecificarFormacaoRouteImport.update({
  id: '/precificar/formacao',
  path: '/precificar/formacao',
  getParentRoute: () => AppRoute,
} as any)
const AppPrecificarListaRoute = AppPrecificarListaRouteImport.update({
  id: '/precificar/lista',
  path: '/precificar/lista',
  getParentRoute: () => AppRoute,
} as any)
const AppPrecificarMargensRoute = AppPrecificarMargensRouteImport.update({
  id: '/precificar/margens',
  path: '/precificar/margens',
  getParentRoute: () => AppRoute,
} as any)
const AppPrecificarSimuladorRoute = AppPrecificarSimuladorRouteImport.update({
  id: '/precificar/simulador',
  path: '/precificar/simulador',
  getParentRoute: () => AppRoute,
} as any)
const AppCadastrosItensIndexRoute = AppCadastrosItensIndexRouteImport.update({
  id: '/cadastros/itens/',
  path: '/cadastros/itens/',
  getParentRoute: () => AppRoute,
} as any)
const AppCadastrosItensIdRoute = AppCadastrosItensIdRouteImport.update({
  id: '/cadastros/itens/$id',
  path: '/cadastros/itens/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppCadastrosItensNovoRoute = AppCadastrosItensNovoRouteImport.update({
  id: '/cadastros/itens/novo',
  path: '/cadastros/itens/novo',
  getParentRoute: () => AppRoute,
} as any)
const AppConfiguracoesIntegracoesIndexRoute =
  AppConfiguracoesIntegracoesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppConfiguracoesIntegracoesRoute,
  } as any)
const AppConfiguracoesIntegracoesApiRoute =
  AppConfiguracoesIntegracoesApiRouteImport.update({
    id: '/api',
    path: '/api',
    getParentRoute: () => AppConfiguracoesIntegracoesRoute,
  } as any)
const AppConfiguracoesIntegracoesLogsRoute =
  AppConfiguracoesIntegracoesLogsRouteImport.update({
    id: '/logs',
    path: '/logs',
    getParentRoute: () => AppConfiguracoesIntegracoesRoute,
  } as any)
const AppConfiguracoesIntegracoesProtheusRoute =
  AppConfiguracoesIntegracoesProtheusRouteImport.update({
    id: '/protheus',
    path: '/protheus',
    getParentRoute: () => AppConfiguracoesIntegracoesRoute,
  } as any)
const AppCustosAtualizacoesIndexRoute =
  AppCustosAtualizacoesIndexRouteImport.update({
    id: '/custos/atualizacoes/',
    path: '/custos/atualizacoes/',
    getParentRoute: () => AppRoute,
  } as any)
const AppCustosAtualizacoesIdRoute = AppCustosAtualizacoesIdRouteImport.update({
  id: '/custos/atualizacoes/$id',
  path: '/custos/atualizacoes/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppCustosFichasTecnicasIndexRoute =
  AppCustosFichasTecnicasIndexRouteImport.update({
    id: '/custos/fichas-tecnicas/',
    path: '/custos/fichas-tecnicas/',
    getParentRoute: () => AppRoute,
  } as any)
const AppCustosFichasTecnicasIdRoute =
  AppCustosFichasTecnicasIdRouteImport.update({
    id: '/custos/fichas-tecnicas/$id',
    path: '/custos/fichas-tecnicas/$id',
    getParentRoute: () => AppRoute,
  } as any)
const AppVenderOrcamentosIndexRoute =
  AppVenderOrcamentosIndexRouteImport.update({
    id: '/vender/orcamentos/',
    path: '/vender/orcamentos/',
    getParentRoute: () => AppRoute,
  } as any)
const AppVenderOrcamentosIdRoute = AppVenderOrcamentosIdRouteImport.update({
  id: '/vender/orcamentos/$id',
  path: '/vender/orcamentos/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppVenderOrcamentosKanbanRoute =
  AppVenderOrcamentosKanbanRouteImport.update({
    id: '/vender/orcamentos/kanban',
    path: '/vender/orcamentos/kanban',
    getParentRoute: () => AppRoute,
  } as any)
const AppVenderOrcamentosNovoRoute = AppVenderOrcamentosNovoRouteImport.update({
  id: '/vender/orcamentos/novo',
  path: '/vender/orcamentos/novo',
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/comecar': typeof ComecarRoute
  '/convite': typeof ConviteRoute
  '/login': typeof LoginRoute
  '/trocar-senha': typeof TrocarSenhaRoute
  '/ajuda': typeof AppAjudaRoute
  '/clientes': typeof AppClientesRoute
  '/configuracoes': typeof AppConfiguracoesRouteWithChildren
  '/conta': typeof AppContaRoute
  '/relatorio': typeof AppRelatorioRoute
  '/componentes': typeof DevComponentesRoute
  '/cadastros/cargos': typeof AppCadastrosCargosRoute
  '/cadastros/categorias': typeof AppCadastrosCategoriasRoute
  '/cadastros/condicoes': typeof AppCadastrosCondicoesRoute
  '/cadastros/empresa': typeof AppCadastrosEmpresaRoute
  '/cadastros/fornecedores': typeof AppCadastrosFornecedoresRoute
  '/cadastros/imobilizados': typeof AppCadastrosImobilizadosRoute
  '/cadastros/pessoas': typeof AppCadastrosPessoasRoute
  '/cadastros/tabelas': typeof AppCadastrosTabelasRoute
  '/cadastros/unidades': typeof AppCadastrosUnidadesRoute
  '/cadastros/usuarios': typeof AppCadastrosUsuariosRoute
  '/configuracoes/empresa': typeof AppConfiguracoesEmpresaRoute
  '/configuracoes/empresas': typeof AppConfiguracoesEmpresasRoute
  '/configuracoes/erp': typeof AppConfiguracoesErpRoute
  '/configuracoes/grupos': typeof AppConfiguracoesGruposRoute
  '/configuracoes/integracoes': typeof AppConfiguracoesIntegracoesRouteWithChildren
  '/configuracoes/onboarding': typeof AppConfiguracoesOnboardingRoute
  '/configuracoes/perfis': typeof AppConfiguracoesPerfisRoute
  '/configuracoes/plano': typeof AppConfiguracoesPlanoRoute
  '/configuracoes/reforma': typeof AppConfiguracoesReformaRoute
  '/configuracoes/tenants': typeof AppConfiguracoesTenantsRoute
  '/configuracoes/usuarios': typeof AppConfiguracoesUsuariosRoute
  '/custos/centros': typeof AppCustosCentrosRoute
  '/custos/cifs': typeof AppCustosCifsRoute
  '/custos/configuracoes-rateio': typeof AppCustosConfiguracoesRateioRoute
  '/custos/criterios': typeof AppCustosCriteriosRoute
  '/custos/itens-cif': typeof AppCustosItensCifRoute
  '/custos/pessoal': typeof AppCustosPessoalRoute
  '/custos/rateios': typeof AppCustosRateiosRoute
  '/plano/carteira': typeof AppPlanoCarteiraRoute
  '/plano/compras': typeof AppPlanoComprasRoute
  '/plano/custo-fabrica': typeof AppPlanoCustoFabricaRoute
  '/plano/fluxo': typeof AppPlanoFluxoRoute
  '/plano/necessidade': typeof AppPlanoNecessidadeRoute
  '/precificar/formacao': typeof AppPrecificarFormacaoRoute
  '/precificar/lista': typeof AppPrecificarListaRoute
  '/precificar/margens': typeof AppPrecificarMargensRoute
  '/precificar/simulador': typeof AppPrecificarSimuladorRoute
  '/configuracoes/': typeof AppConfiguracoesIndexRoute
  '/plano/': typeof AppPlanoIndexRoute
  '/cadastros/itens/$id': typeof AppCadastrosItensIdRoute
  '/cadastros/itens/novo': typeof AppCadastrosItensNovoRoute
  '/configuracoes/integracoes/api': typeof AppConfiguracoesIntegracoesApiRoute
  '/configuracoes/integracoes/logs': typeof AppConfiguracoesIntegracoesLogsRoute
  '/configuracoes/integracoes/protheus': typeof AppConfiguracoesIntegracoesProtheusRoute
  '/custos/atualizacoes/$id': typeof AppCustosAtualizacoesIdRoute
  '/custos/fichas-tecnicas/$id': typeof AppCustosFichasTecnicasIdRoute
  '/vender/orcamentos/$id': typeof AppVenderOrcamentosIdRoute
  '/vender/orcamentos/kanban': typeof AppVenderOrcamentosKanbanRoute
  '/vender/orcamentos/novo': typeof AppVenderOrcamentosNovoRoute
  '/cadastros/itens/': typeof AppCadastrosItensIndexRoute
  '/configuracoes/integracoes/': typeof AppConfiguracoesIntegracoesIndexRoute
  '/custos/atualizacoes/': typeof AppCustosAtualizacoesIndexRoute
  '/custos/fichas-tecnicas/': typeof AppCustosFichasTecnicasIndexRoute
  '/vender/orcamentos/': typeof AppVenderOrcamentosIndexRoute
}
export interface FileRoutesByTo {
  '/comecar': typeof ComecarRoute
  '/convite': typeof ConviteRoute
  '/login': typeof LoginRoute
  '/trocar-senha': typeof TrocarSenhaRoute
  '/ajuda': typeof AppAjudaRoute
  '/clientes': typeof AppClientesRoute
  '/conta': typeof AppContaRoute
  '/relatorio': typeof AppRelatorioRoute
  '/componentes': typeof DevComponentesRoute
  '/': typeof AppIndexRoute
  '/cadastros/cargos': typeof AppCadastrosCargosRoute
  '/cadastros/categorias': typeof AppCadastrosCategoriasRoute
  '/cadastros/condicoes': typeof AppCadastrosCondicoesRoute
  '/cadastros/empresa': typeof AppCadastrosEmpresaRoute
  '/cadastros/fornecedores': typeof AppCadastrosFornecedoresRoute
  '/cadastros/imobilizados': typeof AppCadastrosImobilizadosRoute
  '/cadastros/pessoas': typeof AppCadastrosPessoasRoute
  '/cadastros/tabelas': typeof AppCadastrosTabelasRoute
  '/cadastros/unidades': typeof AppCadastrosUnidadesRoute
  '/cadastros/usuarios': typeof AppCadastrosUsuariosRoute
  '/configuracoes/empresa': typeof AppConfiguracoesEmpresaRoute
  '/configuracoes/empresas': typeof AppConfiguracoesEmpresasRoute
  '/configuracoes/erp': typeof AppConfiguracoesErpRoute
  '/configuracoes/grupos': typeof AppConfiguracoesGruposRoute
  '/configuracoes/onboarding': typeof AppConfiguracoesOnboardingRoute
  '/configuracoes/perfis': typeof AppConfiguracoesPerfisRoute
  '/configuracoes/plano': typeof AppConfiguracoesPlanoRoute
  '/configuracoes/reforma': typeof AppConfiguracoesReformaRoute
  '/configuracoes/tenants': typeof AppConfiguracoesTenantsRoute
  '/configuracoes/usuarios': typeof AppConfiguracoesUsuariosRoute
  '/custos/centros': typeof AppCustosCentrosRoute
  '/custos/cifs': typeof AppCustosCifsRoute
  '/custos/configuracoes-rateio': typeof AppCustosConfiguracoesRateioRoute
  '/custos/criterios': typeof AppCustosCriteriosRoute
  '/custos/itens-cif': typeof AppCustosItensCifRoute
  '/custos/pessoal': typeof AppCustosPessoalRoute
  '/custos/rateios': typeof AppCustosRateiosRoute
  '/plano/carteira': typeof AppPlanoCarteiraRoute
  '/plano/compras': typeof AppPlanoComprasRoute
  '/plano/custo-fabrica': typeof AppPlanoCustoFabricaRoute
  '/plano/fluxo': typeof AppPlanoFluxoRoute
  '/plano/necessidade': typeof AppPlanoNecessidadeRoute
  '/precificar/formacao': typeof AppPrecificarFormacaoRoute
  '/precificar/lista': typeof AppPrecificarListaRoute
  '/precificar/margens': typeof AppPrecificarMargensRoute
  '/precificar/simulador': typeof AppPrecificarSimuladorRoute
  '/configuracoes': typeof AppConfiguracoesIndexRoute
  '/plano': typeof AppPlanoIndexRoute
  '/cadastros/itens/$id': typeof AppCadastrosItensIdRoute
  '/cadastros/itens/novo': typeof AppCadastrosItensNovoRoute
  '/configuracoes/integracoes/api': typeof AppConfiguracoesIntegracoesApiRoute
  '/configuracoes/integracoes/logs': typeof AppConfiguracoesIntegracoesLogsRoute
  '/configuracoes/integracoes/protheus': typeof AppConfiguracoesIntegracoesProtheusRoute
  '/custos/atualizacoes/$id': typeof AppCustosAtualizacoesIdRoute
  '/custos/fichas-tecnicas/$id': typeof AppCustosFichasTecnicasIdRoute
  '/vender/orcamentos/$id': typeof AppVenderOrcamentosIdRoute
  '/vender/orcamentos/kanban': typeof AppVenderOrcamentosKanbanRoute
  '/vender/orcamentos/novo': typeof AppVenderOrcamentosNovoRoute
  '/cadastros/itens': typeof AppCadastrosItensIndexRoute
  '/configuracoes/integracoes': typeof AppConfiguracoesIntegracoesIndexRoute
  '/custos/atualizacoes': typeof AppCustosAtualizacoesIndexRoute
  '/custos/fichas-tecnicas': typeof AppCustosFichasTecnicasIndexRoute
  '/vender/orcamentos': typeof AppVenderOrcamentosIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/comecar': typeof ComecarRoute
  '/convite': typeof ConviteRoute
  '/login': typeof LoginRoute
  '/trocar-senha': typeof TrocarSenhaRoute
  '/_app/ajuda': typeof AppAjudaRoute
  '/_app/clientes': typeof AppClientesRoute
  '/_app/configuracoes': typeof AppConfiguracoesRouteWithChildren
  '/_app/conta': typeof AppContaRoute
  '/_app/relatorio': typeof AppRelatorioRoute
  '/_dev/componentes': typeof DevComponentesRoute
  '/_app/': typeof AppIndexRoute
  '/_app/cadastros/cargos': typeof AppCadastrosCargosRoute
  '/_app/cadastros/categorias': typeof AppCadastrosCategoriasRoute
  '/_app/cadastros/condicoes': typeof AppCadastrosCondicoesRoute
  '/_app/cadastros/empresa': typeof AppCadastrosEmpresaRoute
  '/_app/cadastros/fornecedores': typeof AppCadastrosFornecedoresRoute
  '/_app/cadastros/imobilizados': typeof AppCadastrosImobilizadosRoute
  '/_app/cadastros/pessoas': typeof AppCadastrosPessoasRoute
  '/_app/cadastros/tabelas': typeof AppCadastrosTabelasRoute
  '/_app/cadastros/unidades': typeof AppCadastrosUnidadesRoute
  '/_app/cadastros/usuarios': typeof AppCadastrosUsuariosRoute
  '/_app/configuracoes/empresa': typeof AppConfiguracoesEmpresaRoute
  '/_app/configuracoes/empresas': typeof AppConfiguracoesEmpresasRoute
  '/_app/configuracoes/erp': typeof AppConfiguracoesErpRoute
  '/_app/configuracoes/grupos': typeof AppConfiguracoesGruposRoute
  '/_app/configuracoes/integracoes': typeof AppConfiguracoesIntegracoesRouteWithChildren
  '/_app/configuracoes/onboarding': typeof AppConfiguracoesOnboardingRoute
  '/_app/configuracoes/perfis': typeof AppConfiguracoesPerfisRoute
  '/_app/configuracoes/plano': typeof AppConfiguracoesPlanoRoute
  '/_app/configuracoes/reforma': typeof AppConfiguracoesReformaRoute
  '/_app/configuracoes/tenants': typeof AppConfiguracoesTenantsRoute
  '/_app/configuracoes/usuarios': typeof AppConfiguracoesUsuariosRoute
  '/_app/custos/centros': typeof AppCustosCentrosRoute
  '/_app/custos/cifs': typeof AppCustosCifsRoute
  '/_app/custos/configuracoes-rateio': typeof AppCustosConfiguracoesRateioRoute
  '/_app/custos/criterios': typeof AppCustosCriteriosRoute
  '/_app/custos/itens-cif': typeof AppCustosItensCifRoute
  '/_app/custos/pessoal': typeof AppCustosPessoalRoute
  '/_app/custos/rateios': typeof AppCustosRateiosRoute
  '/_app/plano/carteira': typeof AppPlanoCarteiraRoute
  '/_app/plano/compras': typeof AppPlanoComprasRoute
  '/_app/plano/custo-fabrica': typeof AppPlanoCustoFabricaRoute
  '/_app/plano/fluxo': typeof AppPlanoFluxoRoute
  '/_app/plano/necessidade': typeof AppPlanoNecessidadeRoute
  '/_app/precificar/formacao': typeof AppPrecificarFormacaoRoute
  '/_app/precificar/lista': typeof AppPrecificarListaRoute
  '/_app/precificar/margens': typeof AppPrecificarMargensRoute
  '/_app/precificar/simulador': typeof AppPrecificarSimuladorRoute
  '/_app/configuracoes/': typeof AppConfiguracoesIndexRoute
  '/_app/plano/': typeof AppPlanoIndexRoute
  '/_app/cadastros/itens/$id': typeof AppCadastrosItensIdRoute
  '/_app/cadastros/itens/novo': typeof AppCadastrosItensNovoRoute
  '/_app/configuracoes/integracoes/api': typeof AppConfiguracoesIntegracoesApiRoute
  '/_app/configuracoes/integracoes/logs': typeof AppConfiguracoesIntegracoesLogsRoute
  '/_app/configuracoes/integracoes/protheus': typeof AppConfiguracoesIntegracoesProtheusRoute
  '/_app/custos/atualizacoes/$id': typeof AppCustosAtualizacoesIdRoute
  '/_app/custos/fichas-tecnicas/$id': typeof AppCustosFichasTecnicasIdRoute
  '/_app/vender/orcamentos/$id': typeof AppVenderOrcamentosIdRoute
  '/_app/vender/orcamentos/kanban': typeof AppVenderOrcamentosKanbanRoute
  '/_app/vender/orcamentos/novo': typeof AppVenderOrcamentosNovoRoute
  '/_app/cadastros/itens/': typeof AppCadastrosItensIndexRoute
  '/_app/configuracoes/integracoes/': typeof AppConfiguracoesIntegracoesIndexRoute
  '/_app/custos/atualizacoes/': typeof AppCustosAtualizacoesIndexRoute
  '/_app/custos/fichas-tecnicas/': typeof AppCustosFichasTecnicasIndexRoute
  '/_app/vender/orcamentos/': typeof AppVenderOrcamentosIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/comecar'
    | '/convite'
    | '/login'
    | '/trocar-senha'
    | '/ajuda'
    | '/clientes'
    | '/configuracoes'
    | '/conta'
    | '/relatorio'
    | '/componentes'
    | '/cadastros/cargos'
    | '/cadastros/categorias'
    | '/cadastros/condicoes'
    | '/cadastros/empresa'
    | '/cadastros/fornecedores'
    | '/cadastros/imobilizados'
    | '/cadastros/pessoas'
    | '/cadastros/tabelas'
    | '/cadastros/unidades'
    | '/cadastros/usuarios'
    | '/configuracoes/empresa'
    | '/configuracoes/empresas'
    | '/configuracoes/erp'
    | '/configuracoes/grupos'
    | '/configuracoes/integracoes'
    | '/configuracoes/onboarding'
    | '/configuracoes/perfis'
    | '/configuracoes/plano'
    | '/configuracoes/reforma'
    | '/configuracoes/tenants'
    | '/configuracoes/usuarios'
    | '/custos/centros'
    | '/custos/cifs'
    | '/custos/configuracoes-rateio'
    | '/custos/criterios'
    | '/custos/itens-cif'
    | '/custos/pessoal'
    | '/custos/rateios'
    | '/plano/carteira'
    | '/plano/compras'
    | '/plano/custo-fabrica'
    | '/plano/fluxo'
    | '/plano/necessidade'
    | '/precificar/formacao'
    | '/precificar/lista'
    | '/precificar/margens'
    | '/precificar/simulador'
    | '/configuracoes/'
    | '/plano/'
    | '/cadastros/itens/$id'
    | '/cadastros/itens/novo'
    | '/configuracoes/integracoes/api'
    | '/configuracoes/integracoes/logs'
    | '/configuracoes/integracoes/protheus'
    | '/custos/atualizacoes/$id'
    | '/custos/fichas-tecnicas/$id'
    | '/vender/orcamentos/$id'
    | '/vender/orcamentos/kanban'
    | '/vender/orcamentos/novo'
    | '/cadastros/itens/'
    | '/configuracoes/integracoes/'
    | '/custos/atualizacoes/'
    | '/custos/fichas-tecnicas/'
    | '/vender/orcamentos/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/comecar'
    | '/convite'
    | '/login'
    | '/trocar-senha'
    | '/ajuda'
    | '/clientes'
    | '/conta'
    | '/relatorio'
    | '/componentes'
    | '/'
    | '/cadastros/cargos'
    | '/cadastros/categorias'
    | '/cadastros/condicoes'
    | '/cadastros/empresa'
    | '/cadastros/fornecedores'
    | '/cadastros/imobilizados'
    | '/cadastros/pessoas'
    | '/cadastros/tabelas'
    | '/cadastros/unidades'
    | '/cadastros/usuarios'
    | '/configuracoes/empresa'
    | '/configuracoes/empresas'
    | '/configuracoes/erp'
    | '/configuracoes/grupos'
    | '/configuracoes/onboarding'
    | '/configuracoes/perfis'
    | '/configuracoes/plano'
    | '/configuracoes/reforma'
    | '/configuracoes/tenants'
    | '/configuracoes/usuarios'
    | '/custos/centros'
    | '/custos/cifs'
    | '/custos/configuracoes-rateio'
    | '/custos/criterios'
    | '/custos/itens-cif'
    | '/custos/pessoal'
    | '/custos/rateios'
    | '/plano/carteira'
    | '/plano/compras'
    | '/plano/custo-fabrica'
    | '/plano/fluxo'
    | '/plano/necessidade'
    | '/precificar/formacao'
    | '/precificar/lista'
    | '/precificar/margens'
    | '/precificar/simulador'
    | '/configuracoes'
    | '/plano'
    | '/cadastros/itens/$id'
    | '/cadastros/itens/novo'
    | '/configuracoes/integracoes/api'
    | '/configuracoes/integracoes/logs'
    | '/configuracoes/integracoes/protheus'
    | '/custos/atualizacoes/$id'
    | '/custos/fichas-tecnicas/$id'
    | '/vender/orcamentos/$id'
    | '/vender/orcamentos/kanban'
    | '/vender/orcamentos/novo'
    | '/cadastros/itens'
    | '/configuracoes/integracoes'
    | '/custos/atualizacoes'
    | '/custos/fichas-tecnicas'
    | '/vender/orcamentos'
  id:
    | '__root__'
    | '/_app'
    | '/comecar'
    | '/convite'
    | '/login'
    | '/trocar-senha'
    | '/_app/ajuda'
    | '/_app/clientes'
    | '/_app/configuracoes'
    | '/_app/conta'
    | '/_app/relatorio'
    | '/_dev/componentes'
    | '/_app/'
    | '/_app/cadastros/cargos'
    | '/_app/cadastros/categorias'
    | '/_app/cadastros/condicoes'
    | '/_app/cadastros/empresa'
    | '/_app/cadastros/fornecedores'
    | '/_app/cadastros/imobilizados'
    | '/_app/cadastros/pessoas'
    | '/_app/cadastros/tabelas'
    | '/_app/cadastros/unidades'
    | '/_app/cadastros/usuarios'
    | '/_app/configuracoes/empresa'
    | '/_app/configuracoes/empresas'
    | '/_app/configuracoes/erp'
    | '/_app/configuracoes/grupos'
    | '/_app/configuracoes/integracoes'
    | '/_app/configuracoes/onboarding'
    | '/_app/configuracoes/perfis'
    | '/_app/configuracoes/plano'
    | '/_app/configuracoes/reforma'
    | '/_app/configuracoes/tenants'
    | '/_app/configuracoes/usuarios'
    | '/_app/custos/centros'
    | '/_app/custos/cifs'
    | '/_app/custos/configuracoes-rateio'
    | '/_app/custos/criterios'
    | '/_app/custos/itens-cif'
    | '/_app/custos/pessoal'
    | '/_app/custos/rateios'
    | '/_app/plano/carteira'
    | '/_app/plano/compras'
    | '/_app/plano/custo-fabrica'
    | '/_app/plano/fluxo'
    | '/_app/plano/necessidade'
    | '/_app/precificar/formacao'
    | '/_app/precificar/lista'
    | '/_app/precificar/margens'
    | '/_app/precificar/simulador'
    | '/_app/configuracoes/'
    | '/_app/plano/'
    | '/_app/cadastros/itens/$id'
    | '/_app/cadastros/itens/novo'
    | '/_app/configuracoes/integracoes/api'
    | '/_app/configuracoes/integracoes/logs'
    | '/_app/configuracoes/integracoes/protheus'
    | '/_app/custos/atualizacoes/$id'
    | '/_app/custos/fichas-tecnicas/$id'
    | '/_app/vender/orcamentos/$id'
    | '/_app/vender/orcamentos/kanban'
    | '/_app/vender/orcamentos/novo'
    | '/_app/cadastros/itens/'
    | '/_app/configuracoes/integracoes/'
    | '/_app/custos/atualizacoes/'
    | '/_app/custos/fichas-tecnicas/'
    | '/_app/vender/orcamentos/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  ComecarRoute: typeof ComecarRoute
  ConviteRoute: typeof ConviteRoute
  LoginRoute: typeof LoginRoute
  TrocarSenhaRoute: typeof TrocarSenhaRoute
  DevComponentesRoute: typeof DevComponentesRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/comecar': {
      id: '/comecar'
      path: '/comecar'
      fullPath: '/comecar'
      preLoaderRoute: typeof ComecarRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/convite': {
      id: '/convite'
      path: '/convite'
      fullPath: '/convite'
      preLoaderRoute: typeof ConviteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/trocar-senha': {
      id: '/trocar-senha'
      path: '/trocar-senha'
      fullPath: '/trocar-senha'
      preLoaderRoute: typeof TrocarSenhaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/ajuda': {
      id: '/_app/ajuda'
      path: '/ajuda'
      fullPath: '/ajuda'
      preLoaderRoute: typeof AppAjudaRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/clientes': {
      id: '/_app/clientes'
      path: '/clientes'
      fullPath: '/clientes'
      preLoaderRoute: typeof AppClientesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/configuracoes': {
      id: '/_app/configuracoes'
      path: '/configuracoes'
      fullPath: '/configuracoes'
      preLoaderRoute: typeof AppConfiguracoesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/conta': {
      id: '/_app/conta'
      path: '/conta'
      fullPath: '/conta'
      preLoaderRoute: typeof AppContaRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/relatorio': {
      id: '/_app/relatorio'
      path: '/relatorio'
      fullPath: '/relatorio'
      preLoaderRoute: typeof AppRelatorioRouteImport
      parentRoute: typeof AppRoute
    }
    '/_dev/componentes': {
      id: '/_dev/componentes'
      path: '/componentes'
      fullPath: '/componentes'
      preLoaderRoute: typeof DevComponentesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/cadastros/cargos': {
      id: '/_app/cadastros/cargos'
      path: '/cadastros/cargos'
      fullPath: '/cadastros/cargos'
      preLoaderRoute: typeof AppCadastrosCargosRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/cadastros/categorias': {
      id: '/_app/cadastros/categorias'
      path: '/cadastros/categorias'
      fullPath: '/cadastros/categorias'
      preLoaderRoute: typeof AppCadastrosCategoriasRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/cadastros/condicoes': {
      id: '/_app/cadastros/condicoes'
      path: '/cadastros/condicoes'
      fullPath: '/cadastros/condicoes'
      preLoaderRoute: typeof AppCadastrosCondicoesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/cadastros/empresa': {
      id: '/_app/cadastros/empresa'
      path: '/cadastros/empresa'
      fullPath: '/cadastros/empresa'
      preLoaderRoute: typeof AppCadastrosEmpresaRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/cadastros/fornecedores': {
      id: '/_app/cadastros/fornecedores'
      path: '/cadastros/fornecedores'
      fullPath: '/cadastros/fornecedores'
      preLoaderRoute: typeof AppCadastrosFornecedoresRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/cadastros/imobilizados': {
      id: '/_app/cadastros/imobilizados'
      path: '/cadastros/imobilizados'
      fullPath: '/cadastros/imobilizados'
      preLoaderRoute: typeof AppCadastrosImobilizadosRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/cadastros/pessoas': {
      id: '/_app/cadastros/pessoas'
      path: '/cadastros/pessoas'
      fullPath: '/cadastros/pessoas'
      preLoaderRoute: typeof AppCadastrosPessoasRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/cadastros/tabelas': {
      id: '/_app/cadastros/tabelas'
      path: '/cadastros/tabelas'
      fullPath: '/cadastros/tabelas'
      preLoaderRoute: typeof AppCadastrosTabelasRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/cadastros/unidades': {
      id: '/_app/cadastros/unidades'
      path: '/cadastros/unidades'
      fullPath: '/cadastros/unidades'
      preLoaderRoute: typeof AppCadastrosUnidadesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/cadastros/usuarios': {
      id: '/_app/cadastros/usuarios'
      path: '/cadastros/usuarios'
      fullPath: '/cadastros/usuarios'
      preLoaderRoute: typeof AppCadastrosUsuariosRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/configuracoes/': {
      id: '/_app/configuracoes/'
      path: '/'
      fullPath: '/configuracoes/'
      preLoaderRoute: typeof AppConfiguracoesIndexRouteImport
      parentRoute: typeof AppConfiguracoesRoute
    }
    '/_app/configuracoes/empresa': {
      id: '/_app/configuracoes/empresa'
      path: '/empresa'
      fullPath: '/configuracoes/empresa'
      preLoaderRoute: typeof AppConfiguracoesEmpresaRouteImport
      parentRoute: typeof AppConfiguracoesRoute
    }
    '/_app/configuracoes/empresas': {
      id: '/_app/configuracoes/empresas'
      path: '/empresas'
      fullPath: '/configuracoes/empresas'
      preLoaderRoute: typeof AppConfiguracoesEmpresasRouteImport
      parentRoute: typeof AppConfiguracoesRoute
    }
    '/_app/configuracoes/erp': {
      id: '/_app/configuracoes/erp'
      path: '/erp'
      fullPath: '/configuracoes/erp'
      preLoaderRoute: typeof AppConfiguracoesErpRouteImport
      parentRoute: typeof AppConfiguracoesRoute
    }
    '/_app/configuracoes/grupos': {
      id: '/_app/configuracoes/grupos'
      path: '/grupos'
      fullPath: '/configuracoes/grupos'
      preLoaderRoute: typeof AppConfiguracoesGruposRouteImport
      parentRoute: typeof AppConfiguracoesRoute
    }
    '/_app/configuracoes/integracoes': {
      id: '/_app/configuracoes/integracoes'
      path: '/integracoes'
      fullPath: '/configuracoes/integracoes'
      preLoaderRoute: typeof AppConfiguracoesIntegracoesRouteImport
      parentRoute: typeof AppConfiguracoesRoute
    }
    '/_app/configuracoes/onboarding': {
      id: '/_app/configuracoes/onboarding'
      path: '/onboarding'
      fullPath: '/configuracoes/onboarding'
      preLoaderRoute: typeof AppConfiguracoesOnboardingRouteImport
      parentRoute: typeof AppConfiguracoesRoute
    }
    '/_app/configuracoes/perfis': {
      id: '/_app/configuracoes/perfis'
      path: '/perfis'
      fullPath: '/configuracoes/perfis'
      preLoaderRoute: typeof AppConfiguracoesPerfisRouteImport
      parentRoute: typeof AppConfiguracoesRoute
    }
    '/_app/configuracoes/plano': {
      id: '/_app/configuracoes/plano'
      path: '/plano'
      fullPath: '/configuracoes/plano'
      preLoaderRoute: typeof AppConfiguracoesPlanoRouteImport
      parentRoute: typeof AppConfiguracoesRoute
    }
    '/_app/configuracoes/reforma': {
      id: '/_app/configuracoes/reforma'
      path: '/reforma'
      fullPath: '/configuracoes/reforma'
      preLoaderRoute: typeof AppConfiguracoesReformaRouteImport
      parentRoute: typeof AppConfiguracoesRoute
    }
    '/_app/configuracoes/tenants': {
      id: '/_app/configuracoes/tenants'
      path: '/tenants'
      fullPath: '/configuracoes/tenants'
      preLoaderRoute: typeof AppConfiguracoesTenantsRouteImport
      parentRoute: typeof AppConfiguracoesRoute
    }
    '/_app/configuracoes/usuarios': {
      id: '/_app/configuracoes/usuarios'
      path: '/usuarios'
      fullPath: '/configuracoes/usuarios'
      preLoaderRoute: typeof AppConfiguracoesUsuariosRouteImport
      parentRoute: typeof AppConfiguracoesRoute
    }
    '/_app/custos/centros': {
      id: '/_app/custos/centros'
      path: '/custos/centros'
      fullPath: '/custos/centros'
      preLoaderRoute: typeof AppCustosCentrosRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/custos/cifs': {
      id: '/_app/custos/cifs'
      path: '/custos/cifs'
      fullPath: '/custos/cifs'
      preLoaderRoute: typeof AppCustosCifsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/custos/configuracoes-rateio': {
      id: '/_app/custos/configuracoes-rateio'
      path: '/custos/configuracoes-rateio'
      fullPath: '/custos/configuracoes-rateio'
      preLoaderRoute: typeof AppCustosConfiguracoesRateioRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/custos/criterios': {
      id: '/_app/custos/criterios'
      path: '/custos/criterios'
      fullPath: '/custos/criterios'
      preLoaderRoute: typeof AppCustosCriteriosRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/custos/itens-cif': {
      id: '/_app/custos/itens-cif'
      path: '/custos/itens-cif'
      fullPath: '/custos/itens-cif'
      preLoaderRoute: typeof AppCustosItensCifRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/custos/pessoal': {
      id: '/_app/custos/pessoal'
      path: '/custos/pessoal'
      fullPath: '/custos/pessoal'
      preLoaderRoute: typeof AppCustosPessoalRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/custos/rateios': {
      id: '/_app/custos/rateios'
      path: '/custos/rateios'
      fullPath: '/custos/rateios'
      preLoaderRoute: typeof AppCustosRateiosRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/plano/': {
      id: '/_app/plano/'
      path: '/plano'
      fullPath: '/plano/'
      preLoaderRoute: typeof AppPlanoIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/plano/carteira': {
      id: '/_app/plano/carteira'
      path: '/plano/carteira'
      fullPath: '/plano/carteira'
      preLoaderRoute: typeof AppPlanoCarteiraRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/plano/compras': {
      id: '/_app/plano/compras'
      path: '/plano/compras'
      fullPath: '/plano/compras'
      preLoaderRoute: typeof AppPlanoComprasRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/plano/custo-fabrica': {
      id: '/_app/plano/custo-fabrica'
      path: '/plano/custo-fabrica'
      fullPath: '/plano/custo-fabrica'
      preLoaderRoute: typeof AppPlanoCustoFabricaRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/plano/fluxo': {
      id: '/_app/plano/fluxo'
      path: '/plano/fluxo'
      fullPath: '/plano/fluxo'
      preLoaderRoute: typeof AppPlanoFluxoRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/plano/necessidade': {
      id: '/_app/plano/necessidade'
      path: '/plano/necessidade'
      fullPath: '/plano/necessidade'
      preLoaderRoute: typeof AppPlanoNecessidadeRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/precificar/formacao': {
      id: '/_app/precificar/formacao'
      path: '/precificar/formacao'
      fullPath: '/precificar/formacao'
      preLoaderRoute: typeof AppPrecificarFormacaoRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/precificar/lista': {
      id: '/_app/precificar/lista'
      path: '/precificar/lista'
      fullPath: '/precificar/lista'
      preLoaderRoute: typeof AppPrecificarListaRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/precificar/margens': {
      id: '/_app/precificar/margens'
      path: '/precificar/margens'
      fullPath: '/precificar/margens'
      preLoaderRoute: typeof AppPrecificarMargensRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/precificar/simulador': {
      id: '/_app/precificar/simulador'
      path: '/precificar/simulador'
      fullPath: '/precificar/simulador'
      preLoaderRoute: typeof AppPrecificarSimuladorRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/cadastros/itens/': {
      id: '/_app/cadastros/itens/'
      path: '/cadastros/itens'
      fullPath: '/cadastros/itens/'
      preLoaderRoute: typeof AppCadastrosItensIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/cadastros/itens/$id': {
      id: '/_app/cadastros/itens/$id'
      path: '/cadastros/itens/$id'
      fullPath: '/cadastros/itens/$id'
      preLoaderRoute: typeof AppCadastrosItensIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/cadastros/itens/novo': {
      id: '/_app/cadastros/itens/novo'
      path: '/cadastros/itens/novo'
      fullPath: '/cadastros/itens/novo'
      preLoaderRoute: typeof AppCadastrosItensNovoRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/configuracoes/integracoes/': {
      id: '/_app/configuracoes/integracoes/'
      path: '/'
      fullPath: '/configuracoes/integracoes/'
      preLoaderRoute: typeof AppConfiguracoesIntegracoesIndexRouteImport
      parentRoute: typeof AppConfiguracoesIntegracoesRoute
    }
    '/_app/configuracoes/integracoes/api': {
      id: '/_app/configuracoes/integracoes/api'
      path: '/api'
      fullPath: '/configuracoes/integracoes/api'
      preLoaderRoute: typeof AppConfiguracoesIntegracoesApiRouteImport
      parentRoute: typeof AppConfiguracoesIntegracoesRoute
    }
    '/_app/configuracoes/integracoes/logs': {
      id: '/_app/configuracoes/integracoes/logs'
      path: '/logs'
      fullPath: '/configuracoes/integracoes/logs'
      preLoaderRoute: typeof AppConfiguracoesIntegracoesLogsRouteImport
      parentRoute: typeof AppConfiguracoesIntegracoesRoute
    }
    '/_app/configuracoes/integracoes/protheus': {
      id: '/_app/configuracoes/integracoes/protheus'
      path: '/protheus'
      fullPath: '/configuracoes/integracoes/protheus'
      preLoaderRoute: typeof AppConfiguracoesIntegracoesProtheusRouteImport
      parentRoute: typeof AppConfiguracoesIntegracoesRoute
    }
    '/_app/custos/atualizacoes/': {
      id: '/_app/custos/atualizacoes/'
      path: '/custos/atualizacoes'
      fullPath: '/custos/atualizacoes/'
      preLoaderRoute: typeof AppCustosAtualizacoesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/custos/atualizacoes/$id': {
      id: '/_app/custos/atualizacoes/$id'
      path: '/custos/atualizacoes/$id'
      fullPath: '/custos/atualizacoes/$id'
      preLoaderRoute: typeof AppCustosAtualizacoesIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/custos/fichas-tecnicas/': {
      id: '/_app/custos/fichas-tecnicas/'
      path: '/custos/fichas-tecnicas'
      fullPath: '/custos/fichas-tecnicas/'
      preLoaderRoute: typeof AppCustosFichasTecnicasIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/custos/fichas-tecnicas/$id': {
      id: '/_app/custos/fichas-tecnicas/$id'
      path: '/custos/fichas-tecnicas/$id'
      fullPath: '/custos/fichas-tecnicas/$id'
      preLoaderRoute: typeof AppCustosFichasTecnicasIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/vender/orcamentos/': {
      id: '/_app/vender/orcamentos/'
      path: '/vender/orcamentos'
      fullPath: '/vender/orcamentos/'
      preLoaderRoute: typeof AppVenderOrcamentosIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/vender/orcamentos/$id': {
      id: '/_app/vender/orcamentos/$id'
      path: '/vender/orcamentos/$id'
      fullPath: '/vender/orcamentos/$id'
      preLoaderRoute: typeof AppVenderOrcamentosIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/vender/orcamentos/kanban': {
      id: '/_app/vender/orcamentos/kanban'
      path: '/vender/orcamentos/kanban'
      fullPath: '/vender/orcamentos/kanban'
      preLoaderRoute: typeof AppVenderOrcamentosKanbanRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/vender/orcamentos/novo': {
      id: '/_app/vender/orcamentos/novo'
      path: '/vender/orcamentos/novo'
      fullPath: '/vender/orcamentos/novo'
      preLoaderRoute: typeof AppVenderOrcamentosNovoRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppConfiguracoesIntegracoesRouteChildren {
  AppConfiguracoesIntegracoesApiRoute: typeof AppConfiguracoesIntegracoesApiRoute
  AppConfiguracoesIntegracoesLogsRoute: typeof AppConfiguracoesIntegracoesLogsRoute
  AppConfiguracoesIntegracoesProtheusRoute: typeof AppConfiguracoesIntegracoesProtheusRoute
  AppConfiguracoesIntegracoesIndexRoute: typeof AppConfiguracoesIntegracoesIndexRoute
}

const AppConfiguracoesIntegracoesRouteChildren: AppConfiguracoesIntegracoesRouteChildren =
  {
    AppConfiguracoesIntegracoesApiRoute: AppConfiguracoesIntegracoesApiRoute,
    AppConfiguracoesIntegracoesLogsRoute: AppConfiguracoesIntegracoesLogsRoute,
    AppConfiguracoesIntegracoesProtheusRoute:
      AppConfiguracoesIntegracoesProtheusRoute,
    AppConfiguracoesIntegracoesIndexRoute:
      AppConfiguracoesIntegracoesIndexRoute,
  }

const AppConfiguracoesIntegracoesRouteWithChildren =
  AppConfiguracoesIntegracoesRoute._addFileChildren(
    AppConfiguracoesIntegracoesRouteChildren,
  )

interface AppConfiguracoesRouteChildren {
  AppConfiguracoesEmpresaRoute: typeof AppConfiguracoesEmpresaRoute
  AppConfiguracoesEmpresasRoute: typeof AppConfiguracoesEmpresasRoute
  AppConfiguracoesErpRoute: typeof AppConfiguracoesErpRoute
  AppConfiguracoesGruposRoute: typeof AppConfiguracoesGruposRoute
  AppConfiguracoesIntegracoesRoute: typeof AppConfiguracoesIntegracoesRouteWithChildren
  AppConfiguracoesOnboardingRoute: typeof AppConfiguracoesOnboardingRoute
  AppConfiguracoesPerfisRoute: typeof AppConfiguracoesPerfisRoute
  AppConfiguracoesPlanoRoute: typeof AppConfiguracoesPlanoRoute
  AppConfiguracoesReformaRoute: typeof AppConfiguracoesReformaRoute
  AppConfiguracoesTenantsRoute: typeof AppConfiguracoesTenantsRoute
  AppConfiguracoesUsuariosRoute: typeof AppConfiguracoesUsuariosRoute
  AppConfiguracoesIndexRoute: typeof AppConfiguracoesIndexRoute
}

const AppConfiguracoesRouteChildren: AppConfiguracoesRouteChildren = {
  AppConfiguracoesEmpresaRoute: AppConfiguracoesEmpresaRoute,
  AppConfiguracoesEmpresasRoute: AppConfiguracoesEmpresasRoute,
  AppConfiguracoesErpRoute: AppConfiguracoesErpRoute,
  AppConfiguracoesGruposRoute: AppConfiguracoesGruposRoute,
  AppConfiguracoesIntegracoesRoute:
    AppConfiguracoesIntegracoesRouteWithChildren,
  AppConfiguracoesOnboardingRoute: AppConfiguracoesOnboardingRoute,
  AppConfiguracoesPerfisRoute: AppConfiguracoesPerfisRoute,
  AppConfiguracoesPlanoRoute: AppConfiguracoesPlanoRoute,
  AppConfiguracoesReformaRoute: AppConfiguracoesReformaRoute,
  AppConfiguracoesTenantsRoute: AppConfiguracoesTenantsRoute,
  AppConfiguracoesUsuariosRoute: AppConfiguracoesUsuariosRoute,
  AppConfiguracoesIndexRoute: AppConfiguracoesIndexRoute,
}

const AppConfiguracoesRouteWithChildren =
  AppConfiguracoesRoute._addFileChildren(AppConfiguracoesRouteChildren)

interface AppRouteChildren {
  AppAjudaRoute: typeof AppAjudaRoute
  AppClientesRoute: typeof AppClientesRoute
  AppConfiguracoesRoute: typeof AppConfiguracoesRouteWithChildren
  AppContaRoute: typeof AppContaRoute
  AppRelatorioRoute: typeof AppRelatorioRoute
  AppIndexRoute: typeof AppIndexRoute
  AppCadastrosCargosRoute: typeof AppCadastrosCargosRoute
  AppCadastrosCategoriasRoute: typeof AppCadastrosCategoriasRoute
  AppCadastrosCondicoesRoute: typeof AppCadastrosCondicoesRoute
  AppCadastrosEmpresaRoute: typeof AppCadastrosEmpresaRoute
  AppCadastrosFornecedoresRoute: typeof AppCadastrosFornecedoresRoute
  AppCadastrosImobilizadosRoute: typeof AppCadastrosImobilizadosRoute
  AppCadastrosPessoasRoute: typeof AppCadastrosPessoasRoute
  AppCadastrosTabelasRoute: typeof AppCadastrosTabelasRoute
  AppCadastrosUnidadesRoute: typeof AppCadastrosUnidadesRoute
  AppCadastrosUsuariosRoute: typeof AppCadastrosUsuariosRoute
  AppCustosCentrosRoute: typeof AppCustosCentrosRoute
  AppCustosCifsRoute: typeof AppCustosCifsRoute
  AppCustosConfiguracoesRateioRoute: typeof AppCustosConfiguracoesRateioRoute
  AppCustosCriteriosRoute: typeof AppCustosCriteriosRoute
  AppCustosItensCifRoute: typeof AppCustosItensCifRoute
  AppCustosPessoalRoute: typeof AppCustosPessoalRoute
  AppCustosRateiosRoute: typeof AppCustosRateiosRoute
  AppPlanoCarteiraRoute: typeof AppPlanoCarteiraRoute
  AppPlanoComprasRoute: typeof AppPlanoComprasRoute
  AppPlanoCustoFabricaRoute: typeof AppPlanoCustoFabricaRoute
  AppPlanoFluxoRoute: typeof AppPlanoFluxoRoute
  AppPlanoNecessidadeRoute: typeof AppPlanoNecessidadeRoute
  AppPrecificarFormacaoRoute: typeof AppPrecificarFormacaoRoute
  AppPrecificarListaRoute: typeof AppPrecificarListaRoute
  AppPrecificarMargensRoute: typeof AppPrecificarMargensRoute
  AppPrecificarSimuladorRoute: typeof AppPrecificarSimuladorRoute
  AppPlanoIndexRoute: typeof AppPlanoIndexRoute
  AppCadastrosItensIdRoute: typeof AppCadastrosItensIdRoute
  AppCadastrosItensNovoRoute: typeof AppCadastrosItensNovoRoute
  AppCustosAtualizacoesIdRoute: typeof AppCustosAtualizacoesIdRoute
  AppCustosFichasTecnicasIdRoute: typeof AppCustosFichasTecnicasIdRoute
  AppVenderOrcamentosIdRoute: typeof AppVenderOrcamentosIdRoute
  AppVenderOrcamentosKanbanRoute: typeof AppVenderOrcamentosKanbanRoute
  AppVenderOrcamentosNovoRoute: typeof AppVenderOrcamentosNovoRoute
  AppCadastrosItensIndexRoute: typeof AppCadastrosItensIndexRoute
  AppCustosAtualizacoesIndexRoute: typeof AppCustosAtualizacoesIndexRoute
  AppCustosFichasTecnicasIndexRoute: typeof AppCustosFichasTecnicasIndexRoute
  AppVenderOrcamentosIndexRoute: typeof AppVenderOrcamentosIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAjudaRoute: AppAjudaRoute,
  AppClientesRoute: AppClientesRoute,
  AppConfiguracoesRoute: AppConfiguracoesRouteWithChildren,
  AppContaRoute: AppContaRoute,
  AppRelatorioRoute: AppRelatorioRoute,
  AppIndexRoute: AppIndexRoute,
  AppCadastrosCargosRoute: AppCadastrosCargosRoute,
  AppCadastrosCategoriasRoute: AppCadastrosCategoriasRoute,
  AppCadastrosCondicoesRoute: AppCadastrosCondicoesRoute,
  AppCadastrosEmpresaRoute: AppCadastrosEmpresaRoute,
  AppCadastrosFornecedoresRoute: AppCadastrosFornecedoresRoute,
  AppCadastrosImobilizadosRoute: AppCadastrosImobilizadosRoute,
  AppCadastrosPessoasRoute: AppCadastrosPessoasRoute,
  AppCadastrosTabelasRoute: AppCadastrosTabelasRoute,
  AppCadastrosUnidadesRoute: AppCadastrosUnidadesRoute,
  AppCadastrosUsuariosRoute: AppCadastrosUsuariosRoute,
  AppCustosCentrosRoute: AppCustosCentrosRoute,
  AppCustosCifsRoute: AppCustosCifsRoute,
  AppCustosConfiguracoesRateioRoute: AppCustosConfiguracoesRateioRoute,
  AppCustosCriteriosRoute: AppCustosCriteriosRoute,
  AppCustosItensCifRoute: AppCustosItensCifRoute,
  AppCustosPessoalRoute: AppCustosPessoalRoute,
  AppCustosRateiosRoute: AppCustosRateiosRoute,
  AppPlanoCarteiraRoute: AppPlanoCarteiraRoute,
  AppPlanoComprasRoute: AppPlanoComprasRoute,
  AppPlanoCustoFabricaRoute: AppPlanoCustoFabricaRoute,
  AppPlanoFluxoRoute: AppPlanoFluxoRoute,
  AppPlanoNecessidadeRoute: AppPlanoNecessidadeRoute,
  AppPrecificarFormacaoRoute: AppPrecificarFormacaoRoute,
  AppPrecificarListaRoute: AppPrecificarListaRoute,
  AppPrecificarMargensRoute: AppPrecificarMargensRoute,
  AppPrecificarSimuladorRoute: AppPrecificarSimuladorRoute,
  AppPlanoIndexRoute: AppPlanoIndexRoute,
  AppCadastrosItensIdRoute: AppCadastrosItensIdRoute,
  AppCadastrosItensNovoRoute: AppCadastrosItensNovoRoute,
  AppCustosAtualizacoesIdRoute: AppCustosAtualizacoesIdRoute,
  AppCustosFichasTecnicasIdRoute: AppCustosFichasTecnicasIdRoute,
  AppVenderOrcamentosIdRoute: AppVenderOrcamentosIdRoute,
  AppVenderOrcamentosKanbanRoute: AppVenderOrcamentosKanbanRoute,
  AppVenderOrcamentosNovoRoute: AppVenderOrcamentosNovoRoute,
  AppCadastrosItensIndexRoute: AppCadastrosItensIndexRoute,
  AppCustosAtualizacoesIndexRoute: AppCustosAtualizacoesIndexRoute,
  AppCustosFichasTecnicasIndexRoute: AppCustosFichasTecnicasIndexRoute,
  AppVenderOrcamentosIndexRoute: AppVenderOrcamentosIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  ComecarRoute: ComecarRoute,
  ConviteRoute: ConviteRoute,
  LoginRoute: LoginRoute,
  TrocarSenhaRoute: TrocarSenhaRoute,
  DevComponentesRoute: DevComponentesRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
